import React, {Component} from "react";
import {Link, Redirect} from "react-router-dom";
import {Button, Form, Header, Icon, Modal} from "semantic-ui-react";
import api from "../../../api";
import {withTranslation} from "react-i18next";

class EscalateModal extends Component {
    state = {
        message: "",
        loading: false,
    }

    handleChange = (e) => {
        this.setState({message: e.target.value})
    }

    handleReject = () => {
        this.setState({loading: true})
        const message = this.state.message
        console.info(`reject with`, this.state.message)
        this.updateState("eSubcontractorRejected", this.state.message)
            .then(res => {
                if (!res) {
                    window.setTimeout(() => {
                        this.updateState("eSubcontractorRejected", message)
                    }, 1000)
                    console.error("Error while setting eSubcontractorRejected", res)
                } else {
                    console.log(`escalated`)
                }
            })
    }

    updateState(state = "eSubcontractorRejected", message) {
        return api.updateState(state, message || this.state.message)
            .then(res => {
                this.setState({rejected: true})
                console.log(`escalated`, res)
                return res
            })
    }

    render() {
        const {t} = this.props;

        if (this.state.rejected) return <Redirect to="/accept/new"/>
        return (
            <Modal open={true}
                   basic
                   size='small'>
                <Header icon='warning sign'
                        content={t("job.cancel")}/>
                <Modal.Content>
                    <Form>
                        <Form.TextArea label={t("general.error.describe")}
                                       value={this.state.message}
                                       disabled={this.state.loading}
                                       onChange={this.handleChange}
                                       placeholder={t("general.description")}/>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {this.state.loading ? null : <Link to="/">
                        <Button basic inverted>
                            <Icon name='chevron left'/>{t("general.back")}
                        </Button></Link>}
                    <Button disabled={(this.state.message.length < 5)} loading={this.state.loading}
                            onClick={this.handleReject} type="button" color='red' inverted><Icon
                        name='checkmark'/>{t("job.end")}</Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default withTranslation()(EscalateModal)


// WEBPACK FOOTER //
// ./src/pages/components/Modals/EscalateModal.js